import script from "./BulletScreen.vue?vue&type=script&setup=true&lang=js"
export * from "./BulletScreen.vue?vue&type=script&setup=true&lang=js"

import "./BulletScreen.vue?vue&type=style&index=0&id=78b2f990&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-78b2f990"]])

export default __exports__